
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
  import {
    menberlevelList,
    defaultHeader
  } from "@/utils/config"
	import{
		getSearchDate,
		nextDay
	} from "@/utils/index"
  import {
    recommendPerformanceStatisticlist
  } from "@/api/agent_user"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate
    }
  })

  export default class ProductList extends Vue {
    private keyowrds = ''
    private superior = ''
    private grade = null
    private gradelist:any = menberlevelList
    private filterTime = getSearchDate(1).join('/')
    private tablelist:any = []
    private tableloading = false
    private defaultHeader = defaultHeader
    private pageSize = 10
    private pageNo = 1
    private total = 0


    private mounted () {
      this.gettablelist()
    }


    private exportfile(){
      let url = location.origin + '/pc/recommendPerformanceStatistic/export'
      url += '?RoleGrade=' + (this.grade||'')
      url += '&Keywords=' + (this.keyowrds||'')
      url += '&SuperKeywords=' + (this.superior||'')
      if (this.filterTime) {
        var dt = this.filterTime.split('/');
        url += '&StartTime=' + (dt[0]||'')
        url += '&EndTime=' + (nextDay(dt[1],1)||'')
      }
      // console.log(url)
      window.open(url)
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = {
          RoleGrade:this.grade,
          Keywords:this.keyowrds,
          SuperKeywords:this.superior,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        }
        if (this.filterTime) {
          var dt = this.filterTime.split('/');
          data.StartTime = dt[0];
          data.EndTime = nextDay(dt[1],1)
        }
        let res = await recommendPerformanceStatisticlist(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
